import {gql} from '@apollo/client'

export const GET_ORGANISATION = gql`
  query GetOrganisation {
    organisation {
      id
      internalName
      externalName
      gstNumber
      customerNumbersSequence
      invoiceNumbersSequence
      internalColor
      emailDisclaimer
      paymentDetails {
        id
        name
      }
      smsEnabled
      featureFlags
      replyToEmail
    }
  }
`

export const UPDATE_ORGANISATION = gql`
  mutation UpdateOrganisation(
    $internalName: String
    $externalName: String
    $internalColor: String
    $gstNumber: String
    $customerNumbersSequence: Int
    $invoiceNumbersSequence: Int
    $emailDisclaimer: String
    $replyToEmail: String
  ) {
    organisation(
      internalName: $internalName
      externalName: $externalName
      internalColor: $internalColor
      gstNumber: $gstNumber
      customerNumbersSequence: $customerNumbersSequence
      invoiceNumbersSequence: $invoiceNumbersSequence
      emailDisclaimer: $emailDisclaimer
      replyToEmail: $replyToEmail
    ) {
      id
      internalName
      externalName
      gstNumber
      customerNumbersSequence
      invoiceNumbersSequence
      internalColor
      emailDisclaimer
      paymentDetails {
        id
        name
      }
      smsEnabled
      featureFlags
      replyToEmail
    }
  }
`
